import { IJsonQuery } from 'shared/types/api-models/common/json_query';
import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

const SEARCH_REFERRERS = ['/cat.php', '/kupit-', '/snyat-'];

export function getJsonQuery(offer: IOfferSchema) {
  if (typeof document === 'undefined') {
    return null;
  }

  const { referrer } = document;
  const { dealType, offerType, geo } = offer;
  const house = geo.address.find(item => item.type === 'house');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const jsonQuery: any = {
    _type: `${offerType}${dealType}`,
    engine_version: {
      type: 'term',
      value: 2,
    },
    geo: {
      type: 'geo',
      value: [
        {
          type: 'house',
          id: house && house.id,
        },
      ],
    },
  };

  if (offer.category && offer.category.includes('daily')) {
    Object.assign(jsonQuery, {
      for_day: {
        type: 'term',
        value: '1',
      },
    });
  }

  if (referrer && SEARCH_REFERRERS.some(searchReferrer => referrer.includes(searchReferrer))) {
    try {
      const serpJsonQuery: IJsonQuery = JSON.parse(localStorage.getItem('__serp_jsonQuery__') as string);

      if (serpJsonQuery.room) {
        Object.assign(jsonQuery, {
          room: serpJsonQuery.room,
        });
      }
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }

  return jsonQuery;
}
